// import API from 'services/API';
import API from 'services/TAPS_API';

export function saveGP3WithSign(data, id) {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/save`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export default function sendSignedDocument(data, id, version = '') {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/xml${version}`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
